var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLitterWeightReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.59,
    y: 60.02,
    width: 476.42,
    height: 476.42,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "litter_weight_review") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "litter_weight_review"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.58,
    y: 19.33,
    width: 563.33,
    height: 563.33,
    rx: 48.37,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.55,34.33A33.37,33.37,0,0,1,567.91,67.7V534.3a33.37,33.37,0,0,1-33.36,33.37H68A33.37,33.37,0,0,1,34.58,534.3V67.7A33.37,33.37,0,0,1,68,34.33h466.6m0-30H68A63.44,63.44,0,0,0,4.58,67.7V534.3A63.44,63.44,0,0,0,68,597.67h466.6a63.44,63.44,0,0,0,63.36-63.37V67.7A63.44,63.44,0,0,0,534.55,4.33Z",
    fill: "#ffdc8d"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "34.58 413.7 211.59 323.23 402.87 168.17 567.14 106.59",
    fill: "none",
    stroke: "#00b2db",
    strokeMiterlimit: 10,
    strokeWidth: 36
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16.62 335.36 223.3 244.55 383.11 266.94 586.57 161.96",
    fill: "none",
    stroke: "#ff7bac",
    strokeMiterlimit: 10,
    strokeWidth: 36
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.55 510 217.49 384.77 374.7 347.3 594 238.15",
    fill: "none",
    stroke: "#a97fed",
    strokeMiterlimit: 10,
    strokeWidth: 36
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitterWeightReview);
export default __webpack_public_path__ + "static/media/litter_weight_review.ea3c40cda90a5c5129b57bf436de7440.svg";
export { ForwardRef as ReactComponent };